/* eslint-disable @typescript-eslint/no-explicit-any */

export function toOptions<T extends Record<string, any>>(record: T) {
	return Object.entries(record).map(([key, value]) => ({
		label: value,
		value: key,
	})) as { label: T[keyof T]; value: keyof T }[];
}

export function toEntries<T extends Record<string, any>>(record: T) {
	return Object.entries(record).map(([key, value]) => ({
		key,
		value,
	})) as { key: keyof T; value: T[keyof T] }[];
}
